<ion-header>
    <comp-header myText="{{ 'QUIZ.Results.title' | translate}}" [showMenuBtn]="false" [showBackBtn]="true"></comp-header>
</ion-header>
  
  <ion-content class="ion-padding">

    <div class="result-card">
      <div class="result-item">
        <span class="result-label">{{ 'QUIZ.Results.totalQuestions' | translate }}</span>
        <span class="result-value">{{ totalQuestions }}</span>
      </div>

      <div class="result-item">
        <span class="result-label">{{ 'QUIZ.Results.correctAnswers' | translate }}</span>
        <span class="result-value correct">{{ correctAnswers }}</span>
      </div>

      <div class="result-item">
        <span class="result-label">{{ 'QUIZ.Results.wrongAnswers' | translate }}</span>
        <span class="result-value wrong">{{ wrongAnswers }}</span>
      </div>

      <div class="result-item">
        <span class="result-label">{{ 'QUIZ.Results.totalScore' | translate }}</span>
        <span class="result-value score">{{ totalScore }}</span>
      </div>
    </div>

    <div class="result-message" [class.passed]="hasPassed" [class.failed]="!hasPassed">
      <h3>{{ hasPassed ? ('QUIZ.Results.passed' | translate) : ('QUIZ.Results.failed' | translate) }}</h3>
      <p>{{ hasPassed ? ('QUIZ.Results.passedMessage' | translate) : ('QUIZ.Results.failedMessage' | translate) }}</p>
    </div>

  <div class="quiz-results-actions">
    <ion-button expand="block" (click)="goBack()">
      {{ 'QUIZ.Results.backToChat' | translate }}
    </ion-button>
  </div>
</ion-content>
